import * as React from 'react';

import { FOfferType } from '../../../../../JsonQuery';
import { OfferType } from '../../../components/filters/OfferType';
import { IFilterComponentProps } from '../../../types/filters';
import { TAvailableModifierActions } from '../../../types/modifier';
import { useSearchResultsTooltipOpen } from '../../../utils/searchResultsTooltipOpen';
import { useContext } from '../../../utils/useContext';
import { useDealType } from '../../../utils/useDealType';
import { useOfferType } from '../../../utils/useOfferType';
import { getCommercialLink } from './utils/getCommercialLink';

export const OfferTypeContainer: React.FC<IFilterComponentProps> = ({ filterKey, open, onOpen, onClose }) => {
  const { jsonQuery, jsonQueryCount, jsonQueryCountRefreshing, onChange, onApply, onApplyClick } = useContext();
  const dealType = useDealType();
  const offerType = useOfferType();
  const [commercialLink, setCommercialLink] = React.useState('#');
  const action: TAvailableModifierActions = 'setOfferType';
  const openTooltip = useSearchResultsTooltipOpen({ filterKey, actions: [action] });

  const handleApply = React.useCallback(() => {
    if (onApplyClick) {
      onApplyClick({ source: 'tooltip' });
    }

    onApply();
  }, [onApply, onApplyClick]);

  const handleChange = React.useCallback(
    (offerType: FOfferType) => {
      onChange({ action, arguments: [offerType] });
    },
    [onChange],
  );

  React.useEffect(() => {
    setCommercialLink(getCommercialLink(jsonQuery.region?.value[0]));
  }, [jsonQuery]);

  return (
    <OfferType
      open={open}
      dealType={dealType}
      value={offerType}
      commercialLink={commercialLink}
      offersCount={jsonQueryCount}
      offersCountLoading={jsonQueryCountRefreshing}
      onChange={handleChange}
      openTooltip={openTooltip}
      onApply={handleApply}
      onOpen={onOpen}
      onClose={onClose}
    />
  );
};
